/**
 * Stash de checkout — survit au round-trip Stripe (localStorage).
 *
 * Avant de rediriger vers Stripe, on stocke { convId, pendingQuestion } pour
 * pouvoir restituer le contexte à l'utilisateur sur ?checkout=success.
 */

const STASH_KEY = "nanae.checkout.stash";
const JUST_PAID_KEY = "nanae.checkout.justPaid";

export interface CheckoutStash {
  convId?: string;
  pendingQuestion?: string;
  ts: number;
}

export function setCheckoutStash(s: Omit<CheckoutStash, "ts">): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      STASH_KEY,
      JSON.stringify({ ...s, ts: Date.now() }),
    );
  } catch {
    /* ignore */
  }
}

export function getCheckoutStash(): CheckoutStash | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STASH_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CheckoutStash;
    // TTL : 30 min — au-delà on jette
    if (Date.now() - (parsed.ts ?? 0) > 30 * 60_000) {
      window.localStorage.removeItem(STASH_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearCheckoutStash(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STASH_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Marqueur session "l'user vient de payer" — utilisé pour ne pas ré-afficher
 * le dialog d'achat si un 402 retombe juste après (latence webhook).
 */
export function markJustPaid(): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(JUST_PAID_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
}

export function wasJustPaid(windowMs = 90_000): boolean {
  if (typeof window === "undefined") return false;
  try {
    const v = window.sessionStorage.getItem(JUST_PAID_KEY);
    if (!v) return false;
    return Date.now() - Number(v) < windowMs;
  } catch {
    return false;
  }
}

export function clearJustPaid(): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(JUST_PAID_KEY);
  } catch {
    /* ignore */
  }
}
